import { Group } from 'three'
import { useNodeNeighborBaseFloorElevationReactiveMap } from '../../../rx/memo/useNodeNeighborBaseFloorElevationReactiveMap'
import type { Engine } from '../../core/engine/Engine.type'
import type { EntityGraphNode } from '../../core/engine/EntityGraphNode/EntityGraphNode.type'
import type { SwampEntity } from '../../core/entity/EntityType/Swamp'
import createSwampTerrainClusterGroup from '../objects/Trees/Swamp/createSwampTerrainClusterGroup'

export default function createSwampGroup(
  engine: Engine,
  ent: EntityGraphNode<SwampEntity>,
  callback: (group: Group) => void
): void {
  const neighborBaseElevationReactiveMap = useNodeNeighborBaseFloorElevationReactiveMap(engine)
  createSwampTerrainClusterGroup([ent], neighborBaseElevationReactiveMap).then(callback)
}
